import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Slide, Snackbar } from "@material-ui/core";
import TableComponent, { TableOp } from "../../../components/table/TableOps";
import { withRouter } from "react-router-dom";
import ContraRecibo from "../ContraRecibos/ContraRecibo";
import Http from "../../../Http";
import ACCESS from "../../../ACCESS";

class FacturasClientes extends TableComponent {
  componentDidMount() {
    this.tableConfig(
      {
        dataUrl: `envios-factura/filter`,
        deleteUrl: "",
        deleteField: "id",
        modUrl: "/Cobranza/envio-factura",
      },
      TableOp.Table(
        false,
        [
          { label: "Folio", id: "ce_id" },
          { label: "Sucursal destino", id: "sucursal" },
          { label: "Usuario que creó", id: "usuario_creo" },
          { label: "Usuario que recibío", id: "usuario_recibio" },
          { label: "Fecha de recibío", id: "fecha_recibido" },
        ],
        [
          { id: 'edit', icon: 'edit', access: [ACCESS.COBRANZA_ENVIO_FACTURAS.VER_FOLIOS_CREADOS_POR_USUARIO, ACCESS.COBRANZA_ENVIO_FACTURAS.VER_FOLIOS_SUCURSAL_USUARIO, ACCESS.COBRANZA_ENVIO_FACTURAS.VER_TODOS_LOS_FOLIOS] },
          { id: 'recibir', icon: 'check_box', access: [ACCESS.COBRANZA_ENVIO_FACTURAS.RECIBIR_FOLIO] },
        ]
      )
    );
    this.table();
  }

  action = (id, row) => {
    if (id === 'edit') {
      this.props.history.push(`${this.config.modUrl}/${row.ce_id}`)
    }
    else if (id === 'recibir') {
      this.recibir(row)
    }
  }

  recibir = async (row) => {
    this.deleteRow = row;
    this.deleteRow.id = row.ce_id;
    this.setState({
      dialog: {
        title: `¿Marcar el folio ${row.ce_id} como recibido?`,
        body: '',
        options: ['Sí', 'No'],
        show: true,
      }
    })
  }

  dialogClose = async (op) => {
    this.setState({ dialog: { show: false }, loading: true });
    if (op === 1) {
      let Res = await Http.post(`/envios-factura/recibir-folio`, this.deleteRow);
      if (!Res.error) {
        this.table();
        this.setState({
          sbMsg: `Se recibio correctamente el folio ${this.deleteRow.id}`,
          sbOpen: true,
        });
      } else {
        this.setState({
          sbMsg: `Ocurrio un error: ${Res.errMsg}`,
          sbOpen: true,
        });
      }
    }
    this.setState({ loading: false });
  }

  onContraReciboSave = () => {
    this.setState({ crDialog: { visible: false } });
    this.table();
  }

  onContraReciboClose = () => {
    this.setState({ crDialog: { visible: false } });
  }

  render() {
    const { crDialog = { visible: false }, sbMsg, sbOpen } = this.state;
    const { hasAccess } = this.context;
    return (
      <div style={{
        padding: "0px 10px"
      }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          <h1>Envio Facturas</h1>
          {
            hasAccess(ACCESS.COBRANZA_ENVIO_FACTURAS.CREAR_FOLIO) &&
            <Button color="primary" variant={"contained"} onClick={() => { this.props.history.push(`/Cobranza/envio-factura`) }} >
              Nuevo
            </Button>
          }
        </div>
        <this.TableRender />

        <Dialog
          onClose={this.onContraReciboClose}
          open={crDialog.visible}
          fullWidth={true}
          maxWidth={"xl"}
        >
          <DialogTitle onClose={this.onContraReciboClose}>Factura</DialogTitle>
          <DialogContent dividers>
            <ContraRecibo
              clientesFacturas
              factura={crDialog.row}
              onSave={this.onContraReciboSave}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onContraReciboClose}>Cerrar</Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={sbOpen}
          onClose={() => {
            this.setState({ sbOpen: false });
          }}
          TransitionComponent={Slide}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={<span id="message-id">{sbMsg}</span>}
        />
      </div>
    );
  }
}

export default withRouter(FacturasClientes);
